import { useState } from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { ChatwootIntegrationSection } from "@/components/editor/chatwoot-integration-section"
import { GenesysIntegrationSection } from "@/components/editor/genesys-integration-section"

type Provider = "genesys" | "chatwoot"

export function HumanHandoffIntegrations({ chatbotId }: { chatbotId: string }) {
  const [provider, setProvider] = useState<Provider>("genesys")
  return (
    <Tabs value={provider} onValueChange={(value) => setProvider(value as Provider)} className="space-y-5">
      <TabsList aria-label="Provedor de atendimento humano" className="h-auto">
        <TabsTrigger value="genesys" className="px-4 py-2">Genesys Cloud</TabsTrigger>
        <TabsTrigger value="chatwoot" className="px-4 py-2">Chatwoot</TabsTrigger>
      </TabsList>
      <TabsContent value="genesys" className="mt-0"><GenesysIntegrationSection chatbotId={chatbotId} /></TabsContent>
      <TabsContent value="chatwoot" className="mt-0"><ChatwootIntegrationSection chatbotId={chatbotId} /></TabsContent>
    </Tabs>
  )
}
